<template lang="pug">
page-template(title="Produtos")
  grid-container.mt-md-4.pb-10(
    cols="auto",
    cols-md="300px auto",
    gap="0",
    gap-md="80px"
  )
    .d-flex.flex-column.flex-md-row
      div
        v-text-field.mb-6(
          v-if="!sm",
          v-model="search",
          type="search",
          color="primary",
          label="Buscar",
          append-icon="fas fa-search",
          outlined,
          flat,
          hide-details,
          dense,
          tile,
          clearable,
          clear-icon="fas fa-times"
        )
        v-btn.mb-6(v-else, @click="filter = !filter", color="secondary", block)
          span Mostrar Filtro
          v-icon fas fa-filter
        v-slide-y-transition(v-if="!sm || filter")
          div
            .mb-6
              custom-title.mb-3(type="section", simple) Marcas
              v-select(
                v-model="selectedsBrands",
                :items="brandsSelect",
                label="Selecionar marca",
                outlined,
                flat,
                hide-details,
                dense,
                tile,
                multiple
              )
            .mb-6
              custom-title.mb-3(type="section", simple) Categorias
              v-select(
                v-model="selectedCategory",
                :items="categoriesSelect",
                label="Selecionar categoria",
                clear-icon="fas fa-times",
                clearable,
                outlined,
                flat,
                hide-details,
                dense,
                tile
              )
            .mb-6
              custom-title.mb-3(type="section", simple) Subcategorias
              v-select(
                v-if="subcategoriesSelect.length",
                v-model="selectedSubcategory",
                :items="subcategoriesSelect",
                label="Selecionar subcategoria",
                clear-icon="fas fa-times",
                clearable,
                outlined,
                flat,
                hide-details,
                dense,
                tile
              )
              div(v-else-if="!selectedCategory") Nenhuma categoria selecionada.
              div(v-else) Nenhuma subcategoria disponível.
            .mb-6
              custom-title.mb-3(type="section", simple) Sub-subcategorias
              v-select(
                v-if="subsubcategoriesSelect.length",
                v-model="selectedSubsubcategory",
                :items="subsubcategoriesSelect",
                label="Selecionar sub-subcategoria",
                clear-icon="fas fa-times",
                clearable,
                outlined,
                flat,
                hide-details,
                dense,
                tile
              )
              div(v-else-if="!selectedSubcategory") Nenhuma subcategoria selecionada.
              div(v-else) Nenhuma sub-subcategoria disponível.
            v-divider.my-6.my-md-0.mx-md-4(:vertical="!sm")
    div
      template(v-if="!loading")
        template(v-if="products.length")
          grid-list.justify-start(
            col-width-xs="auto",
            col-width-sm="calc(50% - 16px)",
            col-width-md="238px",
            col-width-lg="246px",
            col-width-xl="330px"
          )
            product-card(
              v-for="({ img, title, to }, i) in products",
              :key="i",
              :img="img",
              :title="title",
              :to="to"
            )
          v-pagination.mt-6(
            v-if="products.length && pagesLength",
            v-model="page",
            :length="pagesLength",
            :total-visible="pagesTotalVisible",
            flat
          )
        .d-flex.justify-center(v-else)
          v-alert.mx-auto(type="info", color="secondary") Nenhum produto encontrado.
      .py-10.d-flex.justify-center(v-else)
        v-progress-circular(size="50", color="primary", indeterminate)
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import CustomTitle from "@/components/others/CustomTitle.vue";
import ProductCard from "@/components/cards/Product";
import BrandCard from "@/components/cards/Brand";
import { formatToURL } from "@/components/utils";

export default {
  data: () => ({
    loading: true,
    itemsPerPage: 16,
    pagesTotalVisible: 6,
    totalProducts: 0,
    filter: false,
  }),
  computed: {
    products() {
      return this.$rest("products").list.map(({ id, img, title }) => ({
        img: img ? this.files + "/" + img : "",
        title,
        to: `/produtos/${formatToURL(`${title}-${id}`)}`,
      }));
    },
    brandsSelect() {
      return this.$rest("brands").list.map(({ id, title }) => ({
        text: title,
        value: id,
      }));
    },
    categoriesSelect() {
      return this.$rest("categories").list.map(({ id, title }) => ({
        text: title,
        value: id,
      }));
    },
    subcategoriesSelect() {
      if (!this.selectedCategory) return [];

      return this.$rest("subcategories")
        .list.filter(
          ({ categories_id }) => categories_id == this.selectedCategory
        )
        .map(({ id, title }) => ({
          text: title,
          value: id,
        }));
    },
    subsubcategoriesSelect() {
      if (!this.selectedSubcategory) return [];

      return this.$rest("subsubcategories")
        .list.filter(
          ({ mod_products_subcategories_id }) =>
            mod_products_subcategories_id == this.selectedSubcategory
        )
        .map(({ id, title }) => ({
          text: title,
          value: id,
        }));
    },
    query() {
      return this.$route.query;
    },
    pagesLength() {
      return Math.ceil(this.totalProducts / this.itemsPerPage);
    },
    search: {
      get() {
        return this.query.s || "";
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.s = v;
        else delete query.s;

        delete query.p;

        this.$router.push({ path: "/produtos", query });
      },
    },
    page: {
      get() {
        const p = this.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.p = v;
        else delete query.p;

        this.$router.push({ path: "/produtos", query });
      },
    },
    selectedsBrands: {
      get() {
        const b = this.query.b;
        return b ? b.split(",") : [];
      },
      set(v) {
        const query = { ...this.query };
        if (v.length) query.b = v.join();
        else delete query.b;

        delete query.p;

        this.$router.push({ path: "/produtos", query });
      },
    },
    selectedCategory: {
      get() {
        return this.query.c;
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.c = v;
        else delete query.c;

        delete query.p;
        delete query.sc;
        delete query.ssc;

        this.$router.push({ path: "/produtos", query });
      },
    },
    selectedSubcategory: {
      get() {
        return this.query.sc;
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.sc = v;
        else delete query.sc;

        delete query.ssc;
        delete query.p;

        this.$router.push({ path: "/produtos", query });
      },
    },
    selectedSubsubcategory: {
      get() {
        return this.query.ssc;
      },
      set(v) {
        const query = { ...this.query };
        if (v) query.ssc = v;
        else delete query.ssc;

        delete query.p;

        this.$router.push({ path: "/produtos", query });
      },
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getProducts() {
      this.loading = true;

      const params = { returnTotalItems: 1 };

      if (this.page) params.page = this.page;
      if (this.selectedCategory) params.category = this.selectedCategory;
      if (this.selectedSubcategory)
        params.subcategory = this.selectedSubcategory;
      if (this.selectedSubsubcategory)
        params.subsubcategory = this.selectedSubsubcategory;
      if (this.selectedsBrands.length) params.brands = this.selectedsBrands;
      if (this.search) params.search = this.search;

      this.$rest("products").get({
        params,
        keepCache: true,
        save: (state, { totalItems, list }) => {
          this.totalProducts = totalItems;
          state.list = list;
          this.loading = false;
        },
      });
    },
  },
  watch: {
    $route() {
      this.getProducts();
    },
  },
  beforeCreate() {
    this.$rest("brands").get();
    this.$rest("categories").get();
    this.$rest("subcategories").get();
    this.$rest("subsubcategories").get();
  },
  created() {
    this.getProducts();
  },
  components: {
    PageTemplate,
    CustomTitle,
    ProductCard,
    BrandCard,
  },
};
</script>
